// extracted by mini-css-extract-plugin
export default {"chargeRecordTable":"ChargeRecordTable_chargeRecordTable__PhMXG"};